import {ComponentStatus, InputSignalLatestData, InputSignalStatus, Location} from 'store/rootState';
import { PendingChanges, TriggerRule } from 'components/popup/trigger/Trigger.types';

export enum TriggerStatus {
  ONLINE = 'online',
  OFFLINE = 'offline'
}

export interface Trigger {
  status: TriggerStatus;
  id: number;
  title: string;
  activate?: TriggerRule;
  until?: TriggerRule;
  arrangement_name: string;
  arrangement?: any;
  active?: boolean;
  pending_approval?: boolean;
  pending_changes?: PendingChanges;
}

export interface InputSignalEditProps {
  id: number;
  name: string;
  locations: Location[];
  triggers: Trigger[];
  input_device?: { id: string, name: string };
  type: string;
  status: InputSignalStatus | ComponentStatus;
  latest_data: InputSignalLatestData;
}

export interface InputSignalValues {
  id: number;
  name: string;
  locations: Location[];
  triggers: Trigger[];
  input_device?: { id: string, name: string };
  type: string;
  status: InputSignalStatus | ComponentStatus;
}
